import { ArrowLeft20 } from '@carbon/icons-react';
import React, { FC, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
// import { confirm } from 'components/atoms/modal';
import { confirm } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import { useRevisionsToggle } from '../revision-history/revisions-toggle';

export const TopBarWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: var(--spacing-03) var(--spacing-06);
  border-bottom: 1px solid var(--border-color);
  gap: var(--spacing-04);
`;
export const RevisionsTopBar: FC = () => {
  const translate = useTranslate();
  const { hideRevisionEditor } = useRevisionsToggle();

  const closeRevisionEditor = useCallback(async () => {
    try {
      hideRevisionEditor();
    } catch {
      toastService({
        title: translate('document.close.versions.failure.title'),
        message: translate('document.close.versions.failure.message'),
      }).error();
    }
  }, [hideRevisionEditor, translate]);

  const restoreRevision = async () => {
    // when we upgrade ck we need to make sure this selector remains the same
    try {
      (
        document.querySelector(
          '[data-cke-tooltip-text="Restore this revision"]',
        ) as HTMLButtonElement
      )?.click();
      await hideRevisionEditor();

      toastService({
        title: translate('document.restore.version.success.title'),
        message: translate('document.restore.version.success.message'),
      }).success();
    } catch (error) {
      toastService({
        title: translate('document.restore.version.failure.title'),
        message: translate('document.restore.version.failure.message'),
      }).error();
    }
  };

  const confirmBeforeRestore = () => {
    confirm({
      title: translate('document.confirm.restore.version.title'),
      content: translate('document.confirm.restore.version.message'),
      onOk: restoreRevision,
      okButtonProps: {
        style: {
          backgroundColor: 'var(--blue-60)',
        },
      },
      okText: translate('document.confirm.restore'),
    });
  };

  useEffect(() => {
    return () => {
      hideRevisionEditor();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TopBarWrapper>
      <Button
        onClick={closeRevisionEditor}
        size="small"
        type="text"
        icon={
          <IconWrapper>
            <ArrowLeft20 />
          </IconWrapper>
        }
      />
      <Button onClick={confirmBeforeRestore} type="primary" size="small">
        {translate('document.restore.version')}
      </Button>
    </TopBarWrapper>
  );
};
